export default {
  users: (state, getters) => {
    return state.users
  },
  newUser: (state, getters) => {
    return state.newUser.user
  },
  isParent: (state, getters) => {
    return state.newUser.isTheirParent
  }
}



// WEBPACK FOOTER //
// ./src/app/store/users/getters.js